module.exports = __webpack_public_path__ + "static/img/but.bd73fdbf.png";